import { render, staticRenderFns } from "./projet.vue?vue&type=template&id=656c57ee"
import script from "./projet.vue?vue&type=script&lang=js"
export * from "./projet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports